import {useCallback, useState} from "react";
import {validateCheckRules} from "../../../common/generic-react.functions.js";
import {useCheckboxRules, useGetInput} from "../../../common/generic-react.rules.js";
export function useGeneratedRules({
  rules
}) {
  const allRules = useCheckboxRules();
  const getRules = useCallback(() => [...Object.values(allRules), ...rules || []], [allRules, rules]);
  const [mainRules] = useState(() => getRules());
  return [mainRules];
}
export function useValidationCheckbox({
  inputRef,
  rules
}) {
  const [mainRules] = useGeneratedRules({
    rules
  });
  const [input] = useGetInput({
    inputRef
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [validateOnChange, setValidateOnChange] = useState(false);
  const isValidCheckbox = useCallback((showErrors = true) => {
    const val = input?.checked;
    let error = "";
    if (showErrors) {
      setErrorMessage(error);
    }
    if (mainRules?.length) {
      error = validateCheckRules(mainRules, val, input);
      if (error && showErrors) {
        setErrorMessage(error);
      }
    }
    return !error;
  }, [input, mainRules]);
  return {
    errorMessage: [errorMessage, setErrorMessage],
    validateOnChange: [validateOnChange, setValidateOnChange],
    isValidCheckbox
  };
}
